import { ModelDetailType } from 'src/modules/newCars/types';
import { formatPrice } from 'src/modules/newCars/utils/helper';
import { processModelSeoData } from 'src/modules/newCars/utils/seoContent';
import { FilterVariantList } from '../../../FilterVariantList/FilterVariantList';
import LatestNews from '../../../LatestNews';
import VideoReview from '../../../VideoReview';
import Faq from '../../../content/Faq';
import ScrollableJumbo from '../../../content/ScrollableJumbo';
import Detail from '../Detail';
import Header from '../Header';
import { UnderPriceCars } from '../UnderPriceCars/UnderPriceCars';
import UserReview from '../UserReview';
import s from './VariantTabPage.module.scss';

export const VariantTabPage = ({
  content,
  strapiContent,
}: {
  content: ModelDetailType;
  strapiContent: any;
}) => {
  const a = '';
  return (
    <div className={s.root}>
      <div className={s.image_desc}>
        <Header images={content.vehicleImages} showBottom={false} content={content}/>
        <Detail
          data={content}
          showBottom={false}
          averageRating={strapiContent?.calculatedReview?.totalRating}
          noOfRating={strapiContent?.calculatedReview?.ratingCount}
          price={`${formatPrice(
            content?.modelSeoData?.baseVariantPrice
          )} - ${formatPrice(content?.modelSeoData?.topVariantPrice)}`}
          brandSlug={content?.modelSeoData?.brandSlug}
          modelSlug={content?.modelSeoData?.modelSlug}
        />
      </div>
      <FilterVariantList
      contentData={content}
        list={content?.variants}
        label={`${content?.hero?.brandName} ${content?.hero?.modelName} variants`}
        modelName={content?.hero?.modelName}
        modelImage={content?.hero?.image}
        modelSlug={content?.modelSeoData?.modelSlug}
        brandSlug={content?.modelSeoData?.brandSlug}
      />
      {content && (
        <UnderPriceCars
          content={content} 
        />
      )}
      {strapiContent?.news?.length && (
        <LatestNews
          data={strapiContent.news}
          heading={`${content?.hero?.brandName} ${content?.hero?.modelName} latest news`}
        />
      )}
      {strapiContent?.userReview && (
        <UserReview
          link={`/new-cars/${content?.modelSeoData?.brandSlug}-car/${content?.modelSeoData?.modelSlug}/review`}
          ratingData={strapiContent.userReview}
          calculatedReview={strapiContent.calculatedReview}
        />
      )}
      {strapiContent?.videoReview?.length && (
        <VideoReview data={strapiContent.videoReview} />
      )}
      {strapiContent?.carListing?.mustRead && (
        <ScrollableJumbo
          heading="Must read article"
          description={strapiContent?.carListing?.mustRead}
        />
      )}
      {strapiContent?.carListing?.faqTitle &&
        strapiContent?.carListing?.faqContent && (
          <Faq
            faqTitle={processModelSeoData(
              strapiContent?.carListing?.faqTitle,
              content
            )}
            faqContent={processModelSeoData(
              strapiContent?.carListing?.faqContent,
              content
            )}
          />
        )}
    </div>
  );
};
